<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-id-card-alt</v-icon>
              <span class="px-3">{{ $t('Edit Staff Member Information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 sm4 md3>
              <v-layout row wrap justify-content-start style="margin:0 auto; max-width:200px;">
                <v-flex xs12>
                  <label @click="chooseImage" style="cursor:pointer">
                    <v-hover>
                      <v-card slot-scope="{ hover }" flat color="grey lighten-4" max-width="600">
                        <div class="user-image" :style="{ 'background-image': `url(${imageData})` }">
                          <span v-if="!imageData" class="placeholder">
                            <v-img
                              :src="
                                staffMemberInfo.user_image_path == null ||
                                staffMemberInfo.user_image_path == 'undefined'
                                  ? `${baseUrls.images}/${
                                      staffMemberInfo.theGender === 'Female' ? 'profile-female.png' : 'profile-male.png'
                                    }`
                                  : `${baseUrls.images}/${staffMemberInfo.user_image_path}`
                              "
                              height="232"
                            />
                          </span>
                          <v-expand-transition>
                            <div
                              v-if="hover"
                              class="transition-fast-in-fast-out v-card--reveal white--text headline image-upload-overlay"
                            >
                              <div class="overlay-inner-content">
                                {{ $t('Click To Upload') }}
                              </div>
                            </div>
                          </v-expand-transition>
                        </div>
                      </v-card>
                    </v-hover>
                  </label>
                </v-flex>
                <input
                  type="file"
                  name="user_image_path"
                  ref="fileInput"
                  style="visibility:hidden; width:0; position:absolute; top:-9999px"
                  v-validate="'size:2047|ext:jpeg,jpg,png'"
                  @input="onSelectFile"
                />
                <label @click="chooseImage" class="info white--text file-upload-trigger" ripple>{{
                  $t('Upload Image')
                }}</label>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm8 md9>
              <v-layout row wrap justify-content-end>
                <v-flex xs12 class="px-2">
                  <!-- <div class="caption no-select">{{ $t('Full Name') }}</div> -->
                  <v-text-field
                    v-model="staffMemberInfo.user_full_name"
                    :label="`${$t('Full Name')} *`"
                    name="user_full_name"
                    box
                    hide-details
                    background-color="white"
                    :error="errors.has('user_full_name')"
                    v-validate="'required'"
                  />
                  <v-text-field
                    v-model="staffMemberInfo.email"
                    :label="`${$t('Email')} *`"
                    name="email"
                    box
                    hide-details
                    background-color="white"
                    class="mt-3 mb-2"
                    autocomplete="off"
                    :error="errors.has('email')"
                    v-validate="'required|email'"
                    data-vv-validate-on="blur"
                  />
                </v-flex>

                <v-flex xs6 sm4 class="pa-2">
                  <v-text-field
                    v-model="staffMemberInfo.user_phone"
                    :label="$t('Phone')"
                    name="user_phone"
                    box
                    hide-details
                    background-color="white"
                    :error="errors.has('user_phone')"
                  />
                </v-flex>

                <v-flex xs6 sm4 class="pa-2">
                  <v-autocomplete
                    v-model="staffMemberInfo.user_gender"
                    :items="genderList"
                    :label="$t('Gender')"
                    box
                    hide-details
                    background-color="white"
                    :error="errors.has('user_gender')"
                    data-vv-name="user_gender"
                  />
                </v-flex>

                <v-flex xs6 sm4 class="pa-2">
                  <v-menu v-model="birthDateMenu" full-width max-width="290" :close-on-content-click="false">
                    <v-text-field
                      slot="activator"
                      :value="staffMemberInfo.user_dob"
                      :label="$t('Birth Date')"
                      name="user_dob"
                      prepend-inner-icon="event"
                      box
                      readonly
                      hide-details
                      background-color="white"
                      autocomplete="off"
                      :error="errors.has('user_dob')"
                      v-validate="'date_format:yyyy-MM-dd'"
                    />
                    <v-date-picker @change="birthDateMenu = false" v-model="staffMemberInfo.user_dob" />
                  </v-menu>
                </v-flex>

                <v-flex xs6 sm4 class="pa-2">
                  <v-autocomplete
                    v-model="staffMemberInfo.user_blood_group"
                    :items="bloodGroupsList"
                    :label="$t('Blood Group')"
                    box
                    hide-details
                    background-color="white"
                    :error="errors.has('user_blood_group')"
                    data-vv-name="user_blood_group"
                  />
                </v-flex>

                <v-flex xs6 sm4 class="pa-2">
                  <v-autocomplete
                    v-model="staffMemberInfo.user_marital_status"
                    :items="maritalStatusList"
                    :label="$t('Marital Status')"
                    box
                    hide-details
                    background-color="white"
                    :error="errors.has('user_marital_status')"
                    data-vv-name="user_marital_status"
                  />
                </v-flex>

                <v-flex xs6 sm4 class="pa-2">
                  <v-text-field
                    v-model="staffMemberInfo.user_nationality"
                    :label="$t('Nationality')"
                    name="user_nationality"
                    box
                    hide-details
                    background-color="white"
                    :error="errors.has('user_nationality')"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex xs12 class="py-1 px-2">
              <v-textarea
                v-model="staffMemberInfo.user_address"
                :label="$t('Address')"
                name="user_address"
                box
                hide-details
                height="80"
                background-color="white"
                :error="errors.has('user_address')"
              />
            </v-flex>
            <v-flex xs6 sm4 class="pa-2">
              <v-menu v-model="userJoiningDateMenu" full-width max-width="290" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :value="staffMemberInfo.user_joining_date"
                  :label="$t('Joining Date')"
                  name="user_joining_date"
                  prepend-inner-icon="event"
                  box
                  readonly
                  hide-details
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('user_joining_date')"
                  v-validate="'date_format:yyyy-MM-dd'"
                />
                <v-date-picker @change="userJoiningDateMenu = false" v-model="staffMemberInfo.user_joining_date" />
              </v-menu>
            </v-flex>

            <v-flex xs6 sm4 pa-2>
              <v-text-field
                v-model="staffMemberInfo.user_job_title"
                :label="`${$t('Job Title')}`"
                name="user_job_title"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                :error="errors.has('user_job_title')"
              />
            </v-flex>

            <v-flex xs6 sm4 pa-2>
              <v-text-field
                v-model="staffMemberInfo.base_salary"
                :label="`${$t('Base Salary')}`"
                name="base_salary"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                v-validate="'numeric'"
                :error="errors.has('base_salary')"
              />
            </v-flex>

            <v-flex
              v-if="outletsList.length > 1 && (authUserData.user_id === 1 || authUserData.user_id === 2)"
              xs12
              class="pa-2"
            >
              <v-autocomplete
                v-model="staffMemberInfo.outlet_id_fk"
                :items="outletsList"
                :label="`${$t('Outlet')} *`"
                box
                hide-details
                background-color="white"
                :error="errors.has('outlet_id_fk')"
                data-vv-name="outlet_id_fk"
                v-validate="'required'"
                :menu-props="{ transition: 'slide-y-transition' }"
              />
            </v-flex>

            <v-flex
              xs12
              pa-2
              v-if="outletsList.length > 1 && (authUserData.user_id === 1 || authUserData.user_id === 2)"
            >
              <v-autocomplete
                v-model="sub_outlet_id"
                :items="outletsList"
                :label="$t('Sub Outlet')"
                box
                hide-details
                multiple
                chips
                deletable-chips
                background-color="white"
                class="text-capitalize"
                :menu-props="{ transition: 'slide-y-transition' }"
              />
            </v-flex>

            <v-flex xs12 class="px-2">
              <v-layout justify-start>
                <v-flex sm3 md2 class="pt-3">
                  <v-chip
                    label
                    :color="staffMemberInfo.user_status === 'Active' ? 'success' : 'error'"
                    text-color="white"
                  >
                    <v-icon left tabindex="-1">{{
                      staffMemberInfo.user_status === 'Active' ? 'check_circle' : 'block'
                    }}</v-icon>
                    {{ staffMemberInfo.user_status === 'Active' ? $t('Active') : $t('Inactive') }}
                  </v-chip>
                </v-flex>
                <v-checkbox
                  v-model="staffMemberInfo.user_status"
                  :label="$t('Active')"
                  true-value="Active"
                  false-value="Inactive"
                  color="primary"
                  messages="Please note that if this option is unchecked this user will not be able to login in"
                />
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      sub_outlet_id: [],
      btnUpdateLoading: false,
      birthDateMenu: false,
      userJoiningDateMenu: false,
      imageData: null,
      imageInput: null,
      imageFile: null
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      staffMemberInfo: 'staff/getStaffMemberInfo',
      genderList: 'staff/getGenderList',
      maritalStatusList: 'staff/getMaritalStatusList',
      staffMemberRole: 'staff/getStaffMemberRole',
      bloodGroupsList: 'staff/getBloodGroupsList',
      authUserData: 'auth/getAuthUserData',
      outletsList: 'outlets/getFullOutletsList'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.imageData = null
          this.imageInput = null
          this.imageFile = null
          this.$refs.fileInput.value = ''
          this.sub_outlet_id = []

          if (this.staffMemberInfo.sub_outlet_id_fk !== null) {
            this.staffMemberInfo.sub_outlet_detail.forEach(s => {
              this.sub_outlet_id.push(s.outlet_id)
            })
          }

          this.addEscKeyListener()
        }
      }
    }
  },

  mounted() {
    this.setOutletsList()
  },

  methods: {
    ...mapActions({
      updateStaffMemberInfo: 'staff/updateStaffMemberInfo',
      setOutletsList: 'outlets/setFullOutletsList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    chooseImage() {
      this.$refs.fileInput.click()
    },

    onSelectFile() {
      this.imageInput = this.$refs.fileInput
      this.imageFile = this.imageInput.files

      if (this.imageFile && this.imageFile[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(this.imageFile[0])
        this.$emit('input', this.imageFile[0])
      }
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true

          let formData = new FormData(event.target)
          formData.append('user_gender', this.staffMemberInfo.user_gender || '')
          formData.append('user_blood_group', this.staffMemberInfo.user_blood_group || '')
          formData.append('user_marital_status', this.staffMemberInfo.user_marital_status || '')
          formData.append('user_status', this.staffMemberInfo.user_status)
          formData.set('user_dob', this.staffMemberInfo.user_dob || '')
          formData.set('user_joining_date', this.staffMemberInfo.user_joining_date || '')
          if (this.imageData != null) {
            formData.append('user_image_path', this.imageFile[0])
          }

          if (this.authUserData.user_id === 1 || this.authUserData.user_id === 2) {
            formData.append('outlet_id_fk', this.staffMemberInfo.outlet_id_fk)

            if (this.sub_outlet_id.length > 0) {
              formData.append(`sub_outlet_id_fk[]`, this.sub_outlet_id)
            }
          }

          // for (let pair of formData.entries()) {
          //   console.warn(`${pair[0]}: ${pair[1]}`)
          // }

          let payload = { id: this.staffMemberInfo.user_id, formData }

          this.updateStaffMemberInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
